import { Tooltip } from 'components/InteractiveUIControls/Tooltip/Tooltip';
import { Svgicon } from 'components/Svgicon/Svgicon';
import { type FC } from 'react';

type DocumentCategoryNameProps = {
  categoryName: string,
  isNewDocumentsCategory: boolean,
  isOpen: boolean,
  toggleCategoryOnClick: () => void,
  toggleCategoryOnKeyDown: (event?: React.KeyboardEvent<HTMLDivElement>) => void,
  totalNumberOfNewDocuments: number,
};

export const DocumentCategoryName: FC<DocumentCategoryNameProps> = ({
  categoryName,
  isNewDocumentsCategory,
  isOpen,
  toggleCategoryOnClick,
  toggleCategoryOnKeyDown,
  totalNumberOfNewDocuments,

}) => {
  return (
    <>
      {
        isOpen ?
          <div
            className='flex w-[25rem]  cursor-pointer flex-col items-start ms:py-[0.75rem]'
            onClick={toggleCategoryOnClick}
            onKeyDown={toggleCategoryOnKeyDown}
          >
            <div className='flex w-full items-center gap-[0.375rem] hover:text-main-700'>
              <Svgicon className='size-[1rem]' id='arrow-down' />
              <h3 className='mb-0 text-font-1 font-semibold hover:text-main-700'>
                {categoryName}
              </h3>
            </div>
          </div> :
          <div
            className='w-fill flex cursor-pointer justify-between ms:min-h-16'
            onClick={toggleCategoryOnClick}
            onKeyDown={toggleCategoryOnKeyDown}
          >
            <div className='flex items-center gap-[0.375rem] hover:text-main-700'>
              <Svgicon className='size-[1rem] -rotate-90' id='arrow-down' />
              <h3 className='mb-0 text-font-1 font-semibold hover:text-main-700'>
                {categoryName}
              </h3>
            </div>
            {!isNewDocumentsCategory && totalNumberOfNewDocuments > 0 && <div className='flex items-center'>
              <div className='tooltip-wrapper black w-fit'>
                <Tooltip>{`${totalNumberOfNewDocuments} document${totalNumberOfNewDocuments === 1 ? '' : 's'}`}</Tooltip>
                <div className='flex h-[1.25rem] items-center rounded-large bg-main-700 px-[0.375rem] py-[0.078125rem]'>
                  <p className='m-0 text-font-4 text-white-999'>
                    {totalNumberOfNewDocuments} new
                  </p>
                </div>
              </div>
            </div>}
          </div>
      }
    </>
  );
};
